var guideNewsletter = (function () {
  return {
    init: init,
  };

  var csrfToken, captchaWidgetId;

  function init() {
    //Newsletter form
    var formCheckerElm,
      newsletterFormObj = {},
      newsletterFormChecker = [],
      newsletterForm = document.querySelectorAll('.guide-newsletter__form'),
      newsletterFormClose = document.querySelectorAll('.guide-newsletter-ty__close');

    for (var i = 0; i < newsletterForm.length; i++) {
      newsletterFormObj.formObj = newsletterForm[i];
      newsletterFormObj.index = i;
      newsletterFormObj.uniqueID = bsLib.uniqueID();
      newsletterFormObj.tag = newsletterFormObj.formObj.querySelector('[name="tag"]');
      newsletterFormObj.status = newsletterFormObj.formObj.querySelector('[name="status"]');
      newsletterFormObj.emailField = newsletterFormObj.formObj.querySelector('[name="email"]');
      newsletterFormObj.formsubmit = newsletterFormObj.formObj.querySelector('[name="commit"]');

      newsletterFormChecker[i] = newsletterFormObj;
    }

    for (var i = 0; i < newsletterFormClose.length; i++) {
      newsletterFormClose[i].addEventListener("click", function () {
        var that = this;

        that.parentElement.classList.add("hide");
      });
    }

    var guideForm = (function (csrfToken, guideFormChecker) {
      return {
        setScope: setScope,
        init: init,
        resetForm: resetForm,
        validateFields: _validateFields,
      };

      var guideFormObj = {},
        uniqueID,
        index;

      function setScope(scope) {
        guideFormObj = {};
        index = getFormIndex(scope);
        guideFormObj = guideFormChecker[index];
        uniqueID = guideFormObj.uniqueID;
      }

      function init(captchaWidgetId) {
        return new Promise(function (resolve, reject) {
          if (typeof grecaptcha === 'undefined') {
            reject();
          }

          //Check valid email from rails api
          if (guideFormObj.emailField.dataset.notvalid === '1') {
            var emailError = document.getElementById('email-error' + uniqueID);

            _showError(
              guideFormObj.emailField,
              emailError,
              'email-error' + uniqueID,
              Messages.emailValidationErrors.invalidEmail
            );
            reject();
          }

          var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse(captchaWidgetId) : '';
          if (grecaptchaResponse.length === 0) {
            new bsAlert({
              alertType: 'error',
              timeout: 5000,
              text: Messages.salesAndSupportPage.noRecaptcha,
            });

            reject();
          }

          guideFormObj.formsubmit.setAttribute('disabled', 'disabled');
          guideFormObj.formsubmit.value = guideFormObj.formsubmit.dataset.btndisabled;

          // MailChimp Form Data object
          var mcFormData = {
            email: guideFormObj.emailField.value,
            curr_page_url: window.location.href,
            status: guideFormObj.status.value,
            tag: guideFormObj.tag.value,
            'g-recaptcha-response': grecaptchaResponse,
          };

          //guide ajax success count for newsletter
          var successCount = 0;

          // xhr request for sending form data to MailChimp
          bsLib.ajax(
            'POST',
            bsLib.railsHost() + '/wp-admin/admin-ajax.php',
            {
              action: 'mailchimp_ajax_send_data',
              security: ajax_initialize_script.ajax_nonce, // nonce
              data: JSON.stringify(mcFormData),
            },
            true, //async
            {
              'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
            }, //request header
            function () {
              if (successCount === 0) {
                //Thank You Message
                var guideFeaturedArticle = document.getElementById('guide-featured-article');
                if (guideFeaturedArticle) {
                  guideFeaturedArticle.querySelector('.guide-newsletter').classList.add('hide');
                  guideFeaturedArticle.querySelector('.guide-newsletter-ty').classList.remove('hide');

                  //show images from lazy load
                  lazyLoading.show();
                }

                _logFormSubmit('OnFormSuccess');
                successCount = 1;
                resolve();
              }
            }, //success
            function () {
              _logFormSubmit('FormSubmitError');
              reject();
            } //error object
          );
        });
      }

      function _validateFields(captchaWidgetId) {
        var formValid = true,
          emailError = document.getElementById('email-error' + uniqueID);

        //Remove all errors
        removeAllError();

        guideFormObj.emailField.dataset.notvalid = '0';

        if (guideFormObj.emailField.value == '') {
          formValid = _showError(
            guideFormObj.emailField,
            emailError,
            'email-error' + uniqueID,
            Messages.emailValidationErrors.invalidEmail
          );
        } else if (!bsLib.validEmail(guideFormObj.emailField.value)) {
          formValid = _showError(
            guideFormObj.emailField,
            emailError,
            'email-error' + uniqueID,
            Messages.emailValidationErrors.invalidEmail
          );
        } else {
          //Disable submit button
          guideFormObj.formsubmit.setAttribute('disabled', 'disabled');
          guideFormObj.formsubmit.dataset.valueText = guideFormObj.formsubmit.value;
          guideFormObj.formsubmit.value = Messages.salesAndSupportPage.validateText;

          formValid = false;
          //timeout added for display disabled btn functionality
          setTimeout(function () {
            bsLib.ajax(
              'GET',
              bsLib.railsHost() +
                '/marketing_api/check_email_validation?email=' +
                encodeURIComponent(guideFormObj.emailField.value),
              {},
              false,
              {
                'X-CSRF-Token': csrfToken,
                'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
              },
              function (data) {
                var dataRequest = bsLib.JSONParse(data.response);

                //remove disable
                guideFormObj.formsubmit.removeAttribute('disabled');
                guideFormObj.formsubmit.value = guideFormObj.formsubmit.dataset.valueText;

                if (dataRequest.valid === false) {
                  guideFormObj.emailField.dataset.notvalid = '1';

                  formValid = _showError(
                    guideFormObj.emailField,
                    emailError,
                    'email-error' + uniqueID,
                    Messages.emailValidationErrors.invalidEmail
                  );
                } else {
                  //Init Form functionality
                  if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.execute(captchaWidgetId);
                  }
                }
              },
              function () {}
            );
          }, 0);
        }
        return formValid;
      }

      function _showError(fieldName, fieldError, errorName, errorMessage) {
        inlineError.showError(fieldName, fieldError, errorName, errorMessage);

        //Invalid Error Amplitude events
        WebEventTracker.logEvent(EDS.webEvents, 'InteractedGuideSubscription', {
          action: 'form',
          InvalidInput: true,
          field: fieldName.getAttribute('name'),
          message: errorMessage,
        });

        return false;
      }

      function removeAllError() {
        //Remove all error element
        var errorMsg = guideFormObj.formObj.querySelectorAll('.error-message');
        for (var i = 0; i < errorMsg.length; i++) {
          errorMsg[i].remove();
        }
        //remove error border class
        var errorMsg = guideFormObj.formObj.parentElement.querySelectorAll('.error-border');
        for (var i = 0; i < errorMsg.length; i++) {
          errorMsg[i].classList.remove('error-border');
        }
      }

      //Get form index
      function getFormIndex(formObj) {
        var index;
        for (var i = 0; i < guideFormChecker.length; i++) {
          if (guideFormChecker[i].formObj == formObj) {
            index = guideFormChecker[i].index;
          }
        }

        return index;
      }

      function resetForm() {
        guideFormObj.formObj[0].reset(); //Reset form
      }

      function _logFormSubmit(status) {
        if (status == 'OnFormSuccess') {
          //Send to webtracker
          WebEventTracker.logEvent(EDS.webEvents, 'SubmitGuideSubscription', {
            action: 'form',
            location: 'sidebar',
            success: 'true',
          });

          //GA call
          if (typeof ga !== 'undefined') {
            ga('browserstack.send', 'event', {
              eventCategory: 'GuideNewsletter',
              eventAction: 'SubmitEmail',
              eventLabel: 'Subscribe',
            });
          }
        }
      }
    })(csrfToken, newsletterFormChecker);

    //Guide Form submit
    for (var i = 0; i < newsletterFormChecker.length; i++) {
      formCheckerElm = newsletterFormChecker[i];

      //Interacted with fields
      formCheckerElm.emailField.addEventListener('blur', function (e) {
        captchaWidgetId = renderCaptchaField(guideForm);

        WebEventTracker.logEvent(EDS.webEvents, 'InteractedGuideSubscription', {
          action: 'form',
          location: 'sidebar',
          field: 'email',
        });
      });

      //Submit Contact Form
      formCheckerElm.formObj.addEventListener('submit', function (e) {
        e.preventDefault();
        WebEventTracker.logEvent(EDS.webEvents, 'SubmitGuideSubscription', {
          action: 'form',
          location: 'sidebar',
          field: 'submit',
        });

        captchaWidgetId = renderCaptchaField(guideForm);

        guideForm.setScope(this);

        if (!guideForm.validateFields(captchaWidgetId)) {
          return false;
        }

        return false;
      });
    }
  }

  //set CSRF Token
  function setCSRFToken() {
    // XHR request for user token
    if (!csrfToken) {
      bsLib.ajax(
        'GET',
        bsLib.railsHost() + '/user/token.json',
        {},
        true,
        {},
        // Success message for user token.
        function (data) {
          if (data.readyState === 4) {
            var dataRequest = bsLib.JSONParse(data.response),
              authenticityToken = document.querySelectorAll('input[name="authenticity_token"]');

            for (var i = 0; i < authenticityToken.length; i++) {
              authenticityToken[i].value = dataRequest.csrf_token;
            }
            csrfToken = dataRequest.csrf_token;
          }
        },
        // Custom Error message for user token.
        function () {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    }
  }

  //render Captcha Field
  function renderCaptchaField(guideForm) {
    //set csrf token
    setCSRFToken();

    //remove captcha
    var captchaWidget,
      captchaField = document.getElementById('guideNewsletterCaptcha');

    //recaptcha render from JS
    if (
      typeof grecaptcha !== 'undefined' &&
      typeof grecaptcha.render !== 'undefined' &&
      captchaField.childNodes.length === 0
    ) {
      captchaWidget = grecaptcha.render(captchaField, {
        sitekey: captchaField.dataset.sitekey,
        theme: 'light',
        badge: 'bottomright',
        size: 'invisible',
        callback: function () {
          return guideForm.init(captchaWidget);
        },
      });
    } else if (captchaWidgetId) {
      captchaWidget = captchaWidgetId;
    }
    return captchaWidget;
  }
})();

/**
 * Recaptcha File load
 */
window.addEventListener('load', function () {
  //init guideNewsletter
  guideNewsletter.init();

  // load recaptcha JS after page load
  document.addEventListener('click', function () {
    var captchaField = document.getElementById('recaptcha-js');
    if (!captchaField && typeof grecaptcha === 'undefined') {
      var scriptElm = document.createElement('script');
      scriptElm.setAttribute('id', 'recaptcha-js');
      scriptElm.setAttribute('type', 'text/javascript');
      scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
      scriptElm.setAttribute('defer', 'defer');
      document.body.appendChild(scriptElm);
    }
  });
});
